var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 104.207,
    viewBox: "0 0 88.935 104.207",
    width: 88.935,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m217.919 385.1v11.679l-10.181 5.988-9.882-5.988v-11.679l9.882 5.989zm-54.5-40.425 9.882 5.989v20.063l17.068 10.181v11.679l-26.95-15.871zm88.635 0v32.041l-27.249 15.871v-11.68l17.068-10.181v-20.062zm-27.248-15.875 10.181 5.988v11.679l-17.068 10.181v20.363l-9.882 5.989-9.882-5.988v-20.36l-17.667-10.181v-11.678l10.181-5.988 17.069 10.181zm-44.318 26.052 9.882 5.988v11.679l-9.882-5.988zm54.5 0v11.679l-9.882 5.988v-11.675zm-61.688-36.229 10.181 5.989-10.181 5.988v11.679l-9.882-5.988v-11.679zm68.873 0 10.181 5.989v11.679l-10.181 5.988v-11.679l-9.882-5.988zm-34.436 0 10.181 5.989-10.18 5.988-9.882-5.988zm0-20.063 27.249 15.871-9.882 5.988-17.068-10.181-17.367 10.182-9.882-5.988z",
    fill: "#f3ba2f",
    transform: "translate(-163.42 -298.56)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBsc);
export default __webpack_public_path__ + "static/media/ic_bsc.8de996f15b2b762d93e90b3087cd732a.svg";
export { ForwardRef as ReactComponent };